import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {getInitialState} from '@web/slices/deliveryGroup/slice'

import type {DeliveryGroupReducers, MakeCreateSliceOptions} from './interfaces'
import type {DeliveryGroupState} from '@web/slices/deliveryGroup/slice'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<DeliveryGroupState, DeliveryGroupReducers, 'deliveryGroup', SliceSelectors<DeliveryGroupState>>({
        name: 'deliveryGroup',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.deliveryGroup ?? state
            })
        },
    })
